<template>
  <div>
    <div class="admin" v-if="isShow === '1'" @click="toggleClick">
      <div class="admin-box" style="line-height: 36px">
        <svg-icon :class="{ 'icon-img-admin': true }" style="font-size: 10px" icon-class="open" />
      </div>
    </div>
    <div v-else :class="{ 'icon-item': true, 'icon-img-open': isActive }" @click="toggleClick">
      <div :class="{ box: !isActive }">
        <svg-icon
          :class="{ 'icon-img': true, 'icon-search-open': isActive }"
          style="font-size: 16px"
          icon-class="search-top"
        />
        <span :class="{ 'icon-img-open-active': isActive }">
          <svg-icon :class="{ 'icon-img': true }" style="font-size: 10px" icon-class="open" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      isActive: {
        type: Boolean,
        default: false,
      },
      isShow: String,
    },
    methods: {
      toggleClick() {
        this.$emit('toggleClick');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .admin {
    margin: 10px 0;
    // background-color: #333333;
    padding-left: 30px;
    .admin-box {
      display: flex;
      align-items: center;
      height: 36px;
    }
    .icon-img-admin {
      width: 8px;
      height: 8px;
    }
  }
  .icon-item {
    color: #fff;
    .box {
      margin-top: 10px;
      // background-color: #333333;
      height: 36px;
      line-height: 36px;
      .icon-img {
        padding-left: 16px;
      }
    }
  }
  .icon-search-open {
    position: absolute;
    top: 20px;
    left: 30px;
    z-index: 1;
    font-size: 16px;
  }
  .icon-img-open-active {
    display: inline-block;
    // background-color: #333333;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    margin-right: 20px;
    text-align: center;
    line-height: 36px;
    transform: rotate(180deg);
  }
  .icon-img-open {
    text-align: right;
    //position: absolute;
    //top: 23px;
    //right: 30px;
  }
  .hamburger {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
  }

  .hamburger.is-active {
    transform: rotate(180deg);
  }
</style>
